import React from 'react';

export default function AnalyticsInsightCard({ title, description, tone = 'neutral' }) {
  return (
    <div className={`analytics-insight-card ${tone}`}>
      <h4 className="analytics-insight-title">{title}</h4>
      <p className="analytics-insight-description">{description}</p>
    </div>
  );
}

